export default "__VITE_ASSET__D5SoRUx2__"